var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', {
    staticClass: "rule-detail"
  }, [_c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "12",
      "width": "20"
    }
  }, [_vm._v("必要能力")]), _vm._v(" "), _c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2",
      "width": "60"
    }
  }, [_vm._v("执行能力")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "130",
      "rowspan": "2"
    }
  }, [_vm._v("如果让你去组织一次团建，打算如何做？如何快速收集大家意向（很多人会给出“都可以”的回复），如何处理询问后没有人回答的囧状。")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "240"
    }
  }, [_vm._v("1. 做事条理性强，思考有逻辑顺序。"), _c('span', {
    staticClass: "red"
  }, [_vm._v("有完备的计划性。")]), _c('br'), _vm._v("\n        2. 思考全面，会考虑到边缘情况。并给出解决方法。"), _c('br'), _vm._v("\n        3. 针对做事过程中出现的困难，可以有 "), _c('span', {
    staticClass: "red"
  }, [_vm._v("比较合适的解决方案。")]), _c('br'), _vm._v("\n        4.不畏惧困难，有信心和能力解决问题。")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("1. 做事条理性强，思考有逻辑顺序。有一定的计划。"), _c('br'), _vm._v("\n        2. 思考全面，会考虑到边缘情况。并给出解决方法。"), _c('br'), _vm._v("\n        3. 针对做事过程中出现的困难，可以有比较合适的解决方案。")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("1. 做事有条理性，思考有逻辑。"), _c('br'), _vm._v("\n        2. 思考较全面，"), _c('span', {
    staticClass: "red"
  }, [_vm._v("提示下可以比较完备")]), _vm._v("。"), _c('br'), _vm._v("\n        3. 针对做事过程中出现的困难，可以给出解决方案。")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("1.思维条理性不强，想到哪里说到哪里。"), _c('br'), _vm._v("\n        2. 对待问题处理能力不强，不能给出较好的解决方案。"), _c('br'), _vm._v("\n        3. 回答问题缓慢，结构框架凌乱。提示下并无改进。")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("1. 做事基本没有条理 "), _c('br'), _vm._v("\n        2. 基本上对待问题没有好的想法 "), _c('br'), _vm._v("\n        3. 做事情倾向放弃")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("首先在我们共同的群里面问下大家本次团建想做点什么。然后逐一统计大家的意见和建议，最后"), _c('span', {
    staticClass: "green"
  }, [_vm._v("汇总")]), _vm._v("有很明确目标的人。将很明确的这些目标整理出来，假设是看电影这种的，那就买不同的票即可。假设是大家都要一起参与的，那就先问没回复的成员或者是回复“都可以”的成员，"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("点对点的方式")]), _vm._v("，问清楚他们想干嘛之后，"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("再去将还没有统一的意见从新征求下，直到完全统一意见")]), _vm._v("（仅仅针对团队活动，不是类似看电影这种）最后做汇总统一，"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("考虑下一些异常情况的解决方式")]), _vm._v("，例如：票卖完了，原定去的饭店关门了如何处理，最后发送到群里面给大家再次确认没有问题了（回答没有问题，思路严谨，条理清晰）")]), _vm._v(" "), _c('td', [_vm._v("首先在我们共同的群里面问下大家本次团建想做点什么。然后逐一统计大家的意见和建议，最后"), _c('span', {
    staticClass: "green"
  }, [_vm._v("汇总")]), _vm._v("有很明确目标的人。将很明确的这些目标整理出来，假设是看电影这种的，那就买不同的票即可。假设是大家都要一起参与的，那就先问没回复的成员或者是回复“都可以”的成员，"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("点对点的方式")]), _vm._v("，问清楚他们想干嘛之后，"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("考虑下一些异常情况的解决方式")]), _vm._v("，例如：票卖完了，原定去的饭店关门了如何处理，最后做汇总统一，发送到群里面给大家再次确认没有问题了（回答基本没有问题，思路严谨，条理清晰）\n    ")]), _vm._v(" "), _c('td', [_vm._v("首先在我们共同的群里面问下大家本次团建想做点什么。然后逐一统计大家的意见和建议，最后汇总下就好。假设没有人回复的话或者是回复“都可以”的情况下，那我就直接点对点的问下，没有回复的人对本次团建有没有想法，或回复了“都行”的成员看看我目前定的是去 XXX 是否满意。最后做汇总统一，定下大家去做什么就好了。（基本正常的回答了该如何去做，在面试官的引导下能够正常回答一些要点，并且不会紧张）\n    ")]), _vm._v(" "), _c('td', [_vm._v("首先在我们共同的群里面问下大家本次团建想做点什么。然后逐一统计大家的意见和建议，最后汇总下就好。假设没有人回复的话或者是回复“都可以”的情况下，那我就按照“少数服从多数”的规矩，以人数多的一组为主，定下大家去做什么就好了。（基本上完整回答了一个解决的办法，但是完全没有“民主”，没有照顾到其他成员的意愿和想法，自己直接做了决定。在面试官的进一步的引导下，能够回答到一些侧重点，但是还是没有组织性和条理性）")]), _vm._v(" "), _c('td', [_vm._v("就在群里问下，没有响应的我就按照多数人的方法处理就好了。（基本上说是错误的回答，没有理解团建的目的和意义，也没有充分考虑到其他成员的意愿。在面试官\n        的引导下也很难回答出个所以然。）")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("工作态度")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("在测试过程中，我们新接受了一项工作，但是这份工作并不是你擅长的，并且要求完成的时间比较紧张。你会怎么看待或者如何去完成这项工作。（穿插可以提问如果需要加班会怎么处理，合作同事办事效率低并对自己工作造成影响如何处理。）")]), _vm._v(" "), _c('td', [_vm._v("1. 负责的任务能保质保量的完成"), _c('br'), _vm._v("\n        2. 责任心强，有担当"), _c('br'), _vm._v("\n        3. 加班耐性和稳定性极高"), _c('br'), _vm._v("\n        4. 工作积极性高，不懂的问题会主动学习和解决。"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("5. 有精益求精的精神，对自己要求严格。")])]), _vm._v(" "), _c('td', [_vm._v("\n        1. 负责的任务能保质保量的完成"), _c('br'), _vm._v("\n        2. 有责任心"), _c('br'), _vm._v("\n        3. 加班耐性和稳定性极高"), _c('br'), _vm._v("\n        4. 工作积极性高，不懂的问题会主动学习和解决。"), _c('br'), _vm._v("\n        （可以独自承担工作，后续稍作迭代即可）\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        1. 负责的任务能保质保量的完成"), _c('br'), _vm._v("\n        2. 有责任心"), _c('br'), _vm._v("\n        3. 加班耐性和稳定性高（定义）"), _c('br'), _vm._v("\n        4. 不懂的问题不会问。"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("（可以较好的完成工作，但需要后期迭代和主管督促）")])]), _vm._v(" "), _c('td', [_vm._v("\n        1. 部分程度完成任务"), _c('br'), _vm._v("\n        2. 加班耐性和稳定性一般"), _c('br'), _vm._v("\n        （"), _c('span', {
    staticClass: "red"
  }, [_vm._v("工作较为被动")]), _vm._v("，需要经常监督和跟进，工作质量一般，需要迭代数次。）\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 工作态度有一定的问题"), _c('br'), _vm._v("\n        2. 非常反对加班")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n        首先如果交给我的工作我会认真负责的尽最大努力去完成。如果时间比较紧张并且属于我的工作我会"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("主动加班完成")]), _vm._v("。如果是不擅长的，那我可能会和我的主管沟通看是不是有更合适的人选，如果没有那我会"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("尽力去学习并完成工作")]), _vm._v("。如果是我的同事自己没有完成工作并且阻碍了我，那我可能会跟他沟通看是不是可以"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("帮上些忙")]), _vm._v("。或者先做一些不阻碍的工作。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        首先如果交给我的工作我会认真负责的尽最大努力去完成。如果时间比较紧张\n        并且属于我的工作我会"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("主动加班完成")]), _vm._v("。如果是不擅长的，那我会"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("尽力去学习并完成工作")]), _vm._v("。如果是我的同事自己没有完成工作并且阻碍了我，会先做一些不阻碍的工作。（会积极的承担工作，并对加班没有太大意见。可以做好自己本职工作，但缺乏帮他人工作的意识。）\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        首先如果交给我的工作我会认真负责的尽最大努力去完成。如果时间比较紧张并且属于我的工作我会"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("主动加班完成")]), _vm._v("。如果是我的同事自己没有完成工作并且阻碍了我，会\n        先做一些不阻碍的工作。（会积极的承担工作，并对加班没有太大意见。可以做好自己本职工作，但缺乏帮他人工作的意识。但更希望完成自己会做的事情。）\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        会在自己工作时间努力完成工作，"), _c('span', {
    staticClass: "green"
  }, [_vm._v("不太能忍受加班，需要加班的情况下，可以加班一小时左右")]), _vm._v("。更希望可以有人督促的工作，自我约束能力不强。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        工作懒散，不积极。能偷懒的时候就偷懒。\n    ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("沟通协作")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("在我们测试过程中少不了需要和策划和程序进行沟通，假设现在你觉得策划的一个设定很不科学，你会怎么做？如果策划的脾气很差，并且觉得你的建议没有道理，你会怎么做？")]), _vm._v(" "), _c('td', [_vm._v("1. 自我表达流畅自信"), _c('br'), _vm._v("\n        2. 快速理解面试官问题"), _c('br'), _vm._v("\n        3. 回答问题清晰连贯"), _c('br'), _vm._v("\n        4. 积极主动表达更多的相关信息"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("5. 顾及听众的感受，从听众的角度去考虑问题答案。")])]), _vm._v(" "), _c('td', [_vm._v("1. 自我表达流畅自信"), _c('br'), _vm._v("\n        2. 可以理解面试官问题"), _c('br'), _vm._v("\n        3. 回答问题有条理连贯"), _c('br'), _vm._v("\n        4. 积极主动表达更多的相关信息")]), _vm._v(" "), _c('td', [_vm._v("1. 自我表达流畅"), _c('br'), _vm._v("\n        2. 可以理解面试官问题"), _c('br'), _vm._v("\n        3. 回答问题清晰连贯"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("（可以顺利完成问答流程，不能积极主动的表达和思考。）")])]), _vm._v(" "), _c('td', [_vm._v("1. 可以表达自己想法"), _c('br'), _vm._v("\n        2. 可以理解面试官问题"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("（可以正常的沟通，但是组织语言能力较差，回答卡顿。）")])]), _vm._v(" "), _c('td', [_vm._v("1. 沟通有障碍"), _c('br'), _vm._v("\n        2. 正常沟通有一定难度")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n        首先我会跟他进行沟通并阐述我的观点和原因。根据熟悉程度和风格进行适当的调整沟通的语气和方式。为了证明我的观点，我可能会"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("使用一些数据")]), _vm._v("，或者"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("找一些有相同看法的人一起支持我的观点")]), _vm._v("。如果还不能达到目的，我可以后续进行"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("多次沟通和交流")]), _vm._v("。并"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("听取他的想法和原因")]), _vm._v("，再作考虑。当然如果还是不行我可能"), _c('span', {
    staticClass: "green"
  }, [_vm._v("会跟我的上司交流")]), _vm._v("，看看是不是可以让他去沟通。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        首先我会跟他进行沟通并阐述我的观点和原因。根据熟悉程度和风格进行适当的调整沟通的语气和方式。为了证明我的观点，我可能会"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("使用一些数据")]), _vm._v("，或者"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("找一些有相同看法的人一起支持我的观点")]), _vm._v("。如果还不能达到目的，我可以后续进行"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("多次沟通和交流")]), _vm._v("。并听取他的想法和原因，再作考虑。当然如果还是不行我可能"), _c('span', {
    staticClass: "green"
  }, [_vm._v("会跟我的上司交流")]), _vm._v("，看看是不是可以让他去沟通。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        首先我会跟他进行沟通并阐述我的观点和原因。如果还不能达到目的，我可以后续进行"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("多次沟通和交流")]), _vm._v("。当然如果还是不行我可能"), _c('span', {
    staticClass: "green"
  }, [_vm._v("会跟我的上司交流")]), _vm._v("，看看是不是可以让他去沟通。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        首先我会跟他进行沟通并阐述我的观点和原因。当然如果还是不行我可能"), _c('span', {
    staticClass: "green"
  }, [_vm._v("会跟我的上司交流")]), _vm._v("，看看是不是可以让他去沟通。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        我会和他进行沟通吧。\n    ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("认知能力")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n        1.产品负责人过来和QA说：我听说有玩家反馈我们的xx英雄太强了，主QA让你来负责处理这个问题，你怎么做？\n        2. 这个英雄是付费抽取英雄，概率设定付费1w rmb才可以获得，如果英雄确实强度超标，怎么处理？\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 快速理解面试官问题"), _c('br'), _vm._v("\n        2. 逻辑推理能力强"), _c('br'), _vm._v("\n        3. 发散思维能力强"), _c('br'), _vm._v("\n        4. 有很好的抽象思维的能力"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("5. 具有复杂问题拆解成简易能解决问题的能力。")])]), _vm._v(" "), _c('td', [_vm._v("1. 可以理解面试官问题"), _c('br'), _vm._v("\n        2. 有一定的逻辑推理能力"), _c('br'), _vm._v("\n        3. 发散思维能力强"), _c('br'), _vm._v("\n        4. 具有的抽象思维的能力\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 可以理解面试官问题"), _c('br'), _vm._v("\n        2. 逻辑推理能力较差"), _c('br'), _vm._v("\n        3. 有一定发散思维能力"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("（可以顺利完成举一反三过程，而不是换皮后还需要再次教学")])]), _vm._v(" "), _c('td', [_vm._v("1. 可以理解面试官问题"), _c('br'), _vm._v("\n        2. 逻辑推理能力几乎没有"), _c('br'), _vm._v("\n        3. 几乎没有发散思维能力"), _c('br'), _vm._v("\n        （"), _c('span', {
    staticClass: "red"
  }, [_vm._v("（事情换皮后还需要再次教学）")])]), _vm._v(" "), _c('td', [_vm._v("1. 对于面试官的问题理解较差"), _c('br'), _vm._v("\n        2. 逻辑理解经常出现偏差")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n        1. 首先我们需要了解到产品是"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("从什么反馈了解到这一现象的")]), _vm._v("，除了已知渠道我们可以还可以从营销、运维、贴吧、论坛等途径去了解类似问题的信息？是xx英雄太强，还是yy英雄太弱而让人觉得xx英雄太强，避免一刀切。然后我们需要了解"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("问题反馈的频率以及反馈的人")]), _vm._v("，这两个维度都是我们做出决策的重要标准，另外也需要考虑到"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("选手的水平，以及胜率数据")]), _vm._v("，综合以上判断后如果这确实是个问题，我们需要"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("给出产品修改的建议")]), _vm._v("（削弱或者增强另一个英雄来动态平衡），如果这不是一个问题，我们应该"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("给出产品我们得出该结论的原因")]), _vm._v("：反馈人数过少，非关键人物反馈，不足以作为修改的依据"), _c('br'), _vm._v("\n        2. 因为这是一个付费英雄，同时已经证实是过强了，那么处理方式需要"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("考虑到玩家影响")]), _vm._v("，可以通过预先通知，客服沟通的形式来同大R玩家交流所做修改是否会引起玩家的反感；之前也提到过游戏的平衡性不仅仅只能做削弱，也可以"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("增强其他克制英雄")]), _vm._v("，营造一个食物链关系，这样从玩家的角度看，他拥有的英雄并没有变弱，相比削弱影响会降低；综合而言，我们需要处理，但是可以"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("通过一些方式降低影响")])]), _vm._v(" "), _c('td', [_vm._v("\n        1. 首先我们需要了解到产品是"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("从什么反馈了解到这一现象的")]), _vm._v("，除了已知渠道我们可以还可以从营销、运维、贴吧、论坛等途径去了解类似问题的信息？是xx英雄太强，还是yy英雄太弱而让人觉得xx英雄太强，避免一刀切。然后我们需要了解"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("问题反馈的频率以及反馈的人")]), _vm._v("，这两个维度都是我们做出决策的重要标准，如果这确实是个问题，我们需要"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("给出产品修改的建议")]), _vm._v("，如果这不是一个问题，我们应该"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("给出产品我们得出该结论的原因")]), _vm._v("：反馈人数过少，非关键人物反馈，不足以作为修改的依据"), _c('br'), _vm._v("\n        2. 因为这是一个付费英雄，同时已经证实是过强了，那么处理方式需要"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("考虑到玩家影响")]), _vm._v("，可以通过预先通知，客服沟通的形式来同大R玩家交流所做修改是否会引起玩家的反感；然后我们还是需要削弱这个英雄的，因为确实比较强。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        1. 首先我们需要了解到产品是"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("从什么反馈了解到这一现象的")]), _vm._v("，除了已知渠道我们可以还可以从营销、运维、贴吧、论坛等途径去了解类似问题的信息？如果这确实是个问题，我们需要"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("给出产品修改的建议")]), _vm._v("。"), _c('br'), _vm._v("\n        2. 确认这个强度确实是需要修复的，那么就只能开始削弱了\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 询问产品具体的反馈是什么，根据自己的经验考虑下这个英雄强势点在哪里，给出削弱的方案"), _c('br'), _vm._v("\n        2. 比较纠结，不知道怎么做才好，提示这个强度是需要处理的，那么就削弱吧")]), _vm._v(" "), _c('td', [_vm._v("\n        1.那就把这个英雄削弱吧，我觉得xx技能比较强，削弱对应的技能"), _c('br'), _vm._v("\n        2. 感觉应该不能削弱，因为玩家充了很多钱（题干没理解清楚“强度超标”，充了很多钱也不能作为不削弱的标准）\n    ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("游戏经历与游戏热情")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n        谈谈之前玩过哪些游戏，以及这些游戏中的关键特点和模块。（如果可以简单的谈一下游戏的发展过程。）\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 经验丰富，体验游戏种类多"), _c('br'), _vm._v("\n        2. 重度、高端玩家，熟悉各种系统、玩法和功能"), _c('br'), _vm._v("\n        3. 在各类电子竞赛获过奖"), _c('br'), _vm._v("\n        4. 有组织过战队，担任过队长，公会会长等。\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 经验丰富，体验游戏种类多"), _c('br'), _vm._v("\n        2. 了解各种系统、玩法和功能"), _c('br'), _vm._v("\n        3. 至少有1个游戏重度游玩1年以上")]), _vm._v(" "), _c('td', [_vm._v("1. 有较多的游戏经验"), _c('br'), _vm._v("\n        2. 有持续玩游戏的习惯")]), _vm._v(" "), _c('td', [_vm._v("1. 平时玩游戏较少"), _c('br'), _vm._v("\n        2. 只针对性的玩简单的游戏"), _c('br'), _vm._v("\n        （听说过一些游戏玩法，但不清楚玩法细节）")]), _vm._v(" "), _c('td', [_vm._v("1. 基本不玩游戏"), _c('br'), _vm._v("\n        2. 游戏了解来源于看别人玩游戏")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("游戏经历了端游，页游，手游等历程。有rpg,mmp,fps,tps,塔防等多种风格。"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("体验过多款端游")]), _vm._v("，手游，也玩过简单的卡牌和养成类游戏。清楚各个模块，功能，的具体玩法和流程。理解游戏相关设置的原因和目的（比如说：体力值的设置，是为了增加游戏寿命。），了解平衡性相关的设计（知道新英雄需要稍强与老英雄。）了解各个风格应该有的特色和优缺点。并"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("能针对个游戏的优缺点提出改进意见")]), _vm._v("。"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("部分游戏排名靠前或者担任过指挥，会长")])]), _vm._v(" "), _c('td', [_vm._v("\n        了解游戏历史，"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("知道市面上主流的游戏类型。玩过多款，多种类型的游戏。")]), _vm._v("并针对游戏进行了思考。知道各个玩过游戏的优缺点，了解一下游戏秘籍和技巧，并"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("发现过一些 bug 和漏洞")])]), _vm._v(" "), _c('td', [_vm._v("\n        对游戏历史不熟悉，但是"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("非常熟悉几款游戏")]), _vm._v("。了解熟悉游戏的主流模块的玩法了解。"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("游戏术语了解一些")]), _vm._v("，但仅限于自己玩过的游戏。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        玩游戏较少，只玩过几款简单的游戏，消消乐，跑酷等。只了解一些简单的功能签到等。复杂的玩法和功能不了解细节。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        基本不玩游戏，对游戏并没有什么兴趣，或者本身对游戏有反感。\n    ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("学习能力")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n        能说一下最近在学习的内容，或者之前学习某些技术的经历吗？学习了多久，\n        有什么样的学习计划（怎么设计的计划），是不是可以将该技术应用的生活工作中去，遇到\n        不能理解的问题如何解决？\n    ")]), _vm._v(" "), _c('td', [_vm._v("善于学习新的知识领域，能较快自学掌握复杂的专业知识，知识面广泛")]), _vm._v(" "), _c('td', [_vm._v("能独立学习自己专业相关、有一定难度和深度的知识")]), _vm._v(" "), _c('td', [_vm._v("学习能力较弱，只能基本掌握必须的专业知识")]), _vm._v(" "), _c('td', [_vm._v("缺乏学习能力，自己专业知识都无法掌握")]), _vm._v(" "), _c('td', [_vm._v("1. 对所学的知识都没有很好的认知，属于混知识")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n        最近在学习 python 语言，制定了一个学习计划，在"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("6个月内读完《Python 入门》这本书")]), _vm._v("。指定计划的依据根据书的厚度，和测试了一下自己可以接受的页数，以及考虑\n        了复习和稳固的时间。截至目前为止，看到了数据类型一章，还在按照计划进行。学习的知识在生活中有应用，目前会使用 python 处理一些表格和数据。在学习中如果出现了问题会"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("百度")]), _vm._v("或者 "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("Google 寻找解答")]), _vm._v("。"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("StackOverFlow")]), _vm._v(" 是经常访问的网站，很多问题都可以从中得到答案。相信自己可以通过学习解决工作中遇到的各种困难。")]), _vm._v(" "), _c('td', [_vm._v("\n        最近在学习 python 语言，制定了一个学习计划，但是由于基础比较差，进度很慢。"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("截至目前为止，学习了 2 个月")]), _vm._v("，看到了数据类型一章。学习的知识在生活中有应用，目前会使用 python 处理一些表格和数据。在学习中如果出现了问题会"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("百度")]), _vm._v("或者 "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("Google")]), _vm._v("span> 寻找解答。感觉工作中的困难都可以通过学习来解决\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        目前正在学习 python 语言，但是基本上是有时间的时候就是看一会，"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("并没有制定详细完整的计划")]), _vm._v("。目前已经学会一些基础知识，但是很少应用，（在提出简单问题后，可以作答，不能主动想应用。）更希望在有人指导或者培训的情况下学习，"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("自己学习感觉效率不高")]), _vm._v("。遇到问题更喜欢问人，自己不是很了解解决问题的方法。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        目前打算学习 python，"), _c('span', {
    staticClass: "green"
  }, [_vm._v("但是并没有什么时间看，或者还没有什么进展")]), _vm._v("，并没有制定计划。之前学习的内容一般需要较长时间消化了理解，并且应用到实际工作中"), _c('span', {
    staticClass: "green"
  }, [_vm._v("感觉比较困难")]), _vm._v("。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        最近没有学习什么新的技术，之前的学习经验也没有什么可圈可点的地方。\n    ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "9"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "6"
    }
  }, [_vm._v("加分项")]), _vm._v(" "), _c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("游戏经验")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("从面试者最熟悉的游戏引入问题，"), _c('br'), _vm._v("\n        1.你最喜欢的角色是什么？他的特点是什么？"), _c('br'), _vm._v("\n        2.你有办法解决你所提到的这个角色的缺点吗？"), _c('br'), _vm._v("\n        3.你觉得从提升游戏整体体验方面有哪些可以做的")]), _vm._v(" "), _c('td', [_vm._v("1. 对游戏和系统的深度理解"), _c('br'), _vm._v("\n        2. 能提出熟悉游戏的优点，缺点和建议"), _c('br'), _vm._v("\n        3. 能对游戏细节有独到的理解"), _c('br'), _vm._v("\n        4. 能够针对目前游戏情况给出更好的建议"), _c('br'), _vm._v("\n        5 对游戏的发展理解比较好")]), _vm._v(" "), _c('td', [_vm._v("1. 对游戏和系统的有较深度理解"), _c('br'), _vm._v("\n        2. 能提出熟悉游戏的优点，缺点和建议"), _c('br'), _vm._v("\n        3. 能对游戏细节有独到的理解"), _c('br'), _vm._v("\n        4. 能够针对目前游戏情况给出一定的建议"), _c('br'), _vm._v("\n        5. 能同步了解游戏发展趋势")]), _vm._v(" "), _c('td', [_vm._v("1. 对游戏和系统的有较深度理解"), _c('br'), _vm._v("\n        2. 能提出熟悉游戏的优点，缺点和想法"), _c('br'), _vm._v("\n        3. 能对游戏细节有独到的理解"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("（不能提出有效建议）")])]), _vm._v(" "), _c('td', [_vm._v("1. 停留在玩游戏的层次"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("2.从自己感觉出发不是站在游戏角度来理解游戏")]), _c('br'), _vm._v("\n        3. 对游戏本身没有太多想法和建议")]), _vm._v(" "), _c('td', [_vm._v("1. 对游戏本身类型和玩法理解都有偏差"), _c('br'), _vm._v("\n        2. 单纯只是娱乐手段")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n        1. 我最喜欢LOL中的疾风剑豪这个角色，人称“快乐风男”，这个英雄的特色是通过"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("短cd技能造成高额伤害")]), _vm._v("，可以"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("通过操作提高这个英雄的强度")]), _vm._v("，不是脸滚键盘的那种。当然缺点也很明显，他的"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("下限非常低")]), _vm._v("，他的强度预计在中等水平，但是LOL大量的低年龄段玩家造成了存在较多的低水平亚索玩家拉低了这个角色的风评，但是无论如何，这个英雄很快乐。"), _c('br'), _vm._v("\n        2. "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("这个角色的缺点其实也是他的优点")]), _vm._v("，正因为他的下限低，所以设计师才可以提高他的上限，这样也是一种平衡。如果我们需要"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("提升他的下限，那么也需要降低他的上限")]), _vm._v("。一个英雄为什么弱？大概可以分为，容易死，技能难以释放，技能伤害低，那么我们可以简单从这几个方面来提升这个英雄，提高这英雄的生命，将非指向性技能修改为指向性技能，那么这个英雄的伤害我们是否还应该提高呢？我觉得不能，因为我们已经强化了生存以及技能释放难度，这提升了他的下限，如果还提高伤害，那么上限也提升了，"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("这会破坏游戏的平衡。")]), _c('br'), _vm._v("\n        3. 我觉得lol还有一定的发展前景，但是需要"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("关注手游的发展趋势，可以考虑在缩短游戏时间，提升排位体验")]), _vm._v("方面做一些文章，比如加快游戏的节奏，提升兵线的经验、金钱，惩罚游戏内演员，给一些具体的方案等等\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        1. 我最喜欢LOL中的疾风剑豪这个角色，这个英雄的特色是"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("比较秀")]), _vm._v("，可以"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("通过操作提高这个英雄的强度")]), _vm._v("，不是脸滚键盘的那种。当然缺点也很明显，他的"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("下限非常低")]), _vm._v("，他的平均强度在中等偏下，但是LOL大量的低年龄段玩家造成了存在较多的低水平玩家拉低了这个角色的风评，但是无论如何，这个英雄很快乐。"), _c('br'), _vm._v("\n        2. "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("这个角色的缺点其实也是他的优点")]), _vm._v("，正因为他的下限低，所以设计师才可以提高他的上限，这样也是一种平衡。如果我们需要"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("提升他的下限，那么也需要降低他的上限")]), _vm._v("。一个英雄为什么弱？大概可以分为，容易死，技能难以释放，技能伤害低，那么我们可以简单从这几个方面来提升这个英雄，提高这英雄的生命，将非指向性技能修改为指向性技能，提高这个英雄的伤害值"), _c('br'), _vm._v("\n        3. "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("我觉得lol做的挺好的，或许他应该做一个手游试试看")]), _vm._v("（你知道王者荣耀吗？玩的不多吧，你觉得LOL手游版可以从哪些方面胜过王者荣耀呢？对游戏业的趋势不敏锐）\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        1. 我最喜欢LOL中的疾风剑豪这个角色，人称“快乐风男”，这个英雄可以"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("展现我的操作")]), _vm._v("，不是脸滚键盘的那种。我玩这个英雄胜率很高。"), _c('br'), _vm._v("\n        2. 这个角色的缺点我认为是使用难度高，可以考虑适当"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("降低这个英雄的使用难度")]), _vm._v("：提高这英雄的生命，将非指向性技能修改为指向性技能，提高这个英雄的伤害值"), _c('br'), _vm._v("\n        3. "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("总得来说目前游戏体验挺好的，他们最好把游戏内的导演和演员全部封禁")]), _vm._v("（具体怎么做呢？给不出有效的方案）\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        1. 我最喜欢LOL中的疾风剑豪这个角色，人称“快乐风男”，我玩这个英雄胜率很高。"), _c('br'), _vm._v("\n        2. 缺点是容易死吧，"), _c('span', {
    staticClass: "green"
  }, [_vm._v("可能是我操作问题，提升下操作就好了")]), _vm._v("，我觉得可以出一些教学视频来教我们如何克服操作难度比较高的问题"), _c('br'), _vm._v("\n        3. 没什么想法，可能可以做pve吧（PVE已经有了，游戏体验不深入）\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        1. 我觉得什么英雄我都喜欢，要说最喜欢，那就是疾风剑豪，没什么原因就是感觉比较喜欢他"), _c('br'), _vm._v("\n        2. 缺点是容易死吧，可能是我操作问题，提升下操作就好了"), _c('br'), _vm._v("\n        3. 没什么想法可能可以做pve吧（PVE已经有了，游戏体验不深入）\n    ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("计算机基础")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("在我们的测试过程中，不仅有黑盒测试，有能力的话也可以接触到白盒测试，\n        之前有做过什么项目或者写过什么软件么，有的话，简单讲下其原理，另外，假如现在我\n        们有个文件中保存了 10000 个玩家的等级数据，我想得到这些玩家中等级的中位数以及等\n        级是该中位数的玩家的个数，如果要你来写，你大概会怎么写（通过答案及回答的过程来\n        考察应聘者的技术能力）")]), _vm._v(" "), _c('td', [_vm._v("精通计算机各类相关知识，有深入的理解，具备丰富的实践经验")]), _vm._v(" "), _c('td', [_vm._v("熟悉计算机各类相关知识，具备一定实践经验")]), _vm._v(" "), _c('td', [_vm._v("对计算机相关知识理解不够深入，仅限于部分了解")]), _vm._v(" "), _c('td', [_vm._v("只懂得基本的概念")]), _vm._v(" "), _c('td', [_vm._v("对计算机相关知识不了解")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("做过了一些"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("项目或者软件")]), _vm._v("（举例并讲述软件使用相关技术），对于题目，首先我会"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("读取")]), _vm._v("这个文件，使用"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v(" xx 排序方法")]), _vm._v("对玩家的等级进行排序，取中间值得到中位数，再对全部数据进行"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("循环")]), _vm._v("，符合条件则计数加 1，最终计数及为个数（有较强代码能力，能开发工具，技术题目都回答正确）")]), _vm._v(" "), _c('td', [_vm._v("对于题目，首先我会使用"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v(" xx 排序方法")]), _vm._v("对玩家的等级进行排序，取中间值得到\n        中位数，再对全部数据进行"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("循环")]), _vm._v("，符合条件则计数加 1，最终计数及为个数（有基本的代码能力，了解计算机基础知识，技术题目能基本答上）")]), _vm._v(" "), _c('td', [_vm._v("首先我会把数据排序拿到中位数，再对全部数据进行"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("循环")]), _vm._v("，符合条件则计数加1，最终计数及为个数（有基本的计算机知识，知道一些逻辑的实现）")]), _vm._v(" "), _c('td', [_vm._v("我会把他们放在 excel 里，排下序再看下中位数，数下等于这种中位数的个数（完全不了解计算机知识，只能黑盒测试）")]), _vm._v(" "), _c('td', [_vm._v("我会排下序再输出下中位数吧（简历中书写熟练或者掌握一些编程内容但是实际并没有掌握）")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("算法与编程")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("1.求给定整数是否是给定整数集中某两个数之和。只需返回是否。例如：输入：numbers=[2,11,7，15]，target=9输出：True（9=2+7）"), _c('br'), _vm._v("\n        2.每个孩子都有一个满足度，每个饼干都有一个大小，只有饼干的大小大于等于一个孩子的满足度，该孩子才会获得满足。求解最多可以获得满足的孩子数量。如输入:[2,3,4],[1,2,3]，第一个数组表示三个孩子的满足度，第二个数组表示饼干的大小。应输出2，表示这三个饼干只能满足两个孩子。")]), _vm._v(" "), _c('td', [_vm._v("熟悉高级数据结构和算法，有丰富编程实践经验，资深Coder；")]), _vm._v(" "), _c('td', [_vm._v("熟悉基础数据结构和算法，有一定编程经验；")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "red"
  }, [_vm._v("缺乏编程经验，能读懂简单的代码")])]), _vm._v(" "), _c('td', [_vm._v("没有编程经验，能读懂部分代码段")]), _vm._v(" "), _c('td', [_vm._v("完全不了解代码")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("第一二题均可以答出，要求有做一定的优化")]), _vm._v(" "), _c('td', [_vm._v("第一题可以答出，第二题无法答出")]), _vm._v(" "), _c('td', [_vm._v("了解题意，但无法答出第一题")]), _vm._v(" "), _c('td', [_vm._v("不明白题目意思是什么")]), _vm._v(" "), _c('td', [_vm._v("回答不了解算法")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e601df8c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/score-tips/score-tips-tester.vue
// module id = null
// module chunks = 